import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { tokenStore, formatApiError } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined); // undefined=loading, null=not logged in
    const [error, setError] = useState("");

    const refreshUser = useCallback(async () => {
        if (!tokenStore.access) {
            setUser(null);
            return null;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch (e) {
            setUser(null);
            tokenStore.clear();
            return null;
        }
    }, []);

    useEffect(() => {
        refreshUser();
    }, [refreshUser]);

    const login = async (email, password) => {
        setError("");
        try {
            const { data } = await api.post("/auth/login", { email, password });
            tokenStore.set(data.access_token, data.refresh_token);
            setUser(data.user);
            return data.user;
        } catch (e) {
            const msg = formatApiError(e?.response?.data?.detail) || "Login failed";
            setError(msg);
            throw new Error(msg);
        }
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (e) {
            // ignore
        }
        tokenStore.clear();
        setUser(null);
    };

    return (
        <AuthContext.Provider
            value={{ user, error, login, logout, refreshUser }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
